import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/styles";
import CustomButton from "../Button";

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiDialogContent-root": {
    padding: "0 16px 16px 24px",
  },
  "& .MuiDialog-scrollPaper": {
    padding: "0 16px",
  },
  "& .MuiDialog-paperFullWidth": {
    minWidth: "100%",
  },
}));

const FnzTimeoutPopup = ({
  isOpen,
  handleClose,
  testId = "fnz-timeout-alert",
  handleRedirectToTransactionHistory,
}) => {
  return (
    <StyledDialog
      fullWidth
      open={isOpen}
      onClose={handleClose}
      data-cy={testId}
    >
      <DialogTitle>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "700",
            lineHeight: 1.4,
            color: "#000",
          }}
        >
          Pending Confirmation
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: "8px 16px 16px" }}>
        <Typography>
          Please check the transaction status in transaction history and do not
          retry.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "0px 12px 24px",
          margin: 0,
          alignItems: "center",
        }}
      >
        <CustomButton
          text="Go to Transaction History"
          color="#fff"
          backgroundColor="#1278cc"
          onClick={handleRedirectToTransactionHistory}
        />
      </DialogActions>
    </StyledDialog>
  );
};

export default FnzTimeoutPopup;
